import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ProjectsCarrousel from 'components/artectum/slides/featured-projects-artectum';
import ProductDetails from 'components/artectum/item-detail/ProjectDetails';
import useFetch from 'core/hooks/api/useFetch';
import { API_ENDPOINTS } from 'core/constant/API_ENDPOINTS';

const Product_Details = () => {
    const { id } = useParams();
    const [projectData, setProjectData] = useState(null);
    const { data } = useFetch(`${API_ENDPOINTS.PROJECTS}/${id}`);

    useEffect(() => {
        if (data) {
            setProjectData(data);
        }
    }, [data]);

    return (
        <>
            {projectData && <ProductDetails projectData={projectData} />}
            <ProjectsCarrousel sectionClass="py-5" />
        </>
    );
}

export default Product_Details;